export default {
  title: 'Activity Log',
  errorLoading: 'Activity Log could not be loaded.',
  noDiffData: 'The change data could not be loaded.',
  applications: {
    events: 'Events',
    jobmarket: 'Jobmarket',
    articles: 'Articles',
    leihbar: 'LeihBar',
    modules: 'Modules',
    'module-selections': 'AWPM/FWPM' // ? This key has to be like this due to the key being used to query and in the db it is saved with the hyphen
  },
  columns: {
    time: 'Time',
    application: 'Service',
    domain: 'Subdomain',
    description: 'Description',
    action: 'Action',
    type: 'Perpetrator',
    refId: 'Reference Id'
  }
};
